
import React, { useMemo } from 'react';
import {
  Text,
  Icon,
  Bubble
} from "tea-component";
import { useIntl, getLocale } from 'umi';
import cx from 'classnames';
import { formatPercentNum, getIsErrorValue } from '@/pages/dashboard/utils/utils';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { thousandthFormat } from '@/pages/home/utils/common';
import moment from 'moment';
import { EXPLAIN_TITLE_KEYS_MAP, EXPLAIN_DESC_MAP } from './_costant';
import './index.scss';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import CommonBubble from '@home/components/CommonBubble';

const MetricCardItem = (props: any) => {
  const { isMain, isChange, dataSource, timeType = 'Day' ,isMoblie = false, isRealTime,isNightingale, isPlaceholderTime = false, isRightCard = false,} = props;
  const {
    unit = '',
    type,
    decimal = 2,
    name,
    metrics_name,
    value,
    mainValueBubble,
    showRateValue = true,
    explain,
    bubbleData = {},
    formatRule,
    useChangeAmount = false,
    subMetric = null, // 子指标数据 { name: string, value: string }
  } = dataSource || {};
  const { formatMessage } = useIntl();

  /**
 * @param key metrics_name标识 根据标识展示unit
 * @param value 数值
 */
  const formatterValue = (key: string, value: string): string => {
    if (getIsErrorValue(value)) return '-';
    const _foramtVal: any = thousandthFormat(value, type === 'int' ? 0 : decimal, true, '-');
    return _foramtVal;
  };

  const getVal = (val: string, key?: any) => !getIsErrorValue(val) && type === 'percent' ? formatPercentNum(parseFloat(val), decimal) : formatterValue(key || '-', val);

  /**
 * @param data 卡片变化率数据
 */
  const itemCont = (data: any, ind: number) => {
    if (!data) return null;
    const { title, this_time, last_time, this_value, last_value, desc } = data || {};
    const isEn = getLocale() === 'en-US';

    const topVal = formatRule ? dataFormat({ value: this_value, formatRule}) : getVal(this_value, metrics_name);
    const bottomVal = formatRule ? dataFormat({ value: last_value, formatRule}) : getVal(last_value, metrics_name);
    return (
      <div className='bubble-item' key={`${ind  }itemCont`}>
        <div className='bubble-title'>{title} <Text className='bubble-desc'>{isEn && desc ? `(${desc})` : ''}</Text></div>
        <div className='bubble-flex' style={{ whiteSpace: 'nowrap'}}>
          <div className='bubble-text'>
            <div className='bubble-t'>{this_time || '-'}</div>
            <div className='bubble-b'>{last_time || '-'}</div>
          </div>
          <div className='bubble-ct'>VS</div>
          <div className='bubble-text'>
            <div className='bubble-t'>{(topVal !== '-' ? unit : '') + topVal}</div>
            <div className='bubble-b'>{(bottomVal !== '-' ? unit : '') + bottomVal}</div>
          </div>
        </div>
      </div>
    );
  };

  const titleKeys = useMemo(() => EXPLAIN_TITLE_KEYS_MAP?.[timeType?.toLowerCase()] || EXPLAIN_TITLE_KEYS_MAP?.day, [bubbleData, timeType]);

  // 卡片下方显示同比和环比涨跌的组件
  const UpsAndDownsComparison = () => {
    const keys = Object.keys(bubbleData || {});

    const renderIcon = (value: number) => {
      if (typeof value !== 'number') return null;
      if (value === 0) return <Icon type={'trend-zero'} />;
      if (value > 0) return <SvgIcon className='overlay-card-body-icon' type="green-up-new" />;
      return <SvgIcon className='overlay-card-body-icon' type="red-down-new" />;
    };

    const renderChange = (value: number, formattedValue: string | number, isValid: boolean, key: number) => {
      return (
        <div key={key} style={{ justifyContent: 'flex-start' }} className={cx("overlay-card-body-textnum", {
          "text-green": isValid && value > 0,
          "text-red": isValid && value < 0,
          "text-gray": value === 0,
        })}>
          {isValid ? formattedValue : <span className="data-null"> -</span>}
          {isValid && renderIcon(value)}
        </div>
      );
    };

    return (
      <div className="overlay-card-body-flex">
        <div className='overlay-card-body-flex-item'>
          {
            titleKeys?.map((key: string, ki: number) => {
              const lIsChange = isChange && key === 'change';
              const lNotIsChange = !isChange && key !== 'change';

              if (lIsChange || lNotIsChange) {
                let id = `overview_${key}`;
                if (lIsChange && useChangeAmount) {
                  id = `overview_change_amount`;
                }

                return <div key={ki} className='overlay-card-body-text'>{formatMessage({ id })}</div>;
              }

              return null;
            })
          }
        </div>
        <div className='overlay-card-body-flex-rightitem'>
          {
            (keys && keys.length > 0) ? (
              keys?.map((key, ki) => {
                const {
                  /** 变化率 */
                  show_value: showValue,
                  /** 变化量 = this_value - last_value */
                  this_value: thisValue = 0,
                  last_value: lastValue = 0,
                  change_amount: bdChangeAmount = 0,
                } = bubbleData[key] || {};
                const correctVal = !getIsErrorValue(showValue);
                const lIsChange = isChange && key === 'change';
                const lNotIsChange = !isChange && key !== 'change';

                if (lIsChange || lNotIsChange) {
                  if (lIsChange && useChangeAmount) {
                    const tvIsValid = Number.isFinite(thisValue);
                    const lvIsValid = Number.isFinite(lastValue);
                    const areBothFinite = tvIsValid && lvIsValid;
                    const changeAmount = areBothFinite ? bdChangeAmount : 0;
                    const formattedChangeAmount = dataFormat({value: changeAmount, formatRule});

                    return renderChange(changeAmount, formattedChangeAmount, areBothFinite, ki);
                  }

                  return renderChange(Number(showValue), formatPercentNum(parseFloat(showValue), 1, true), correctVal, ki);
                }

                return null;
              })
            ) : (
              titleKeys?.map((key: string, index: number) => (
                (isChange && key === 'change') || (!isChange && key !== 'change') ? (
                  <div key={index} style={{ justifyContent: 'flex-start' }} className="overlay-card-body-textnum">
                    <span className="data-null"> -</span> 
                  </div>
                ) : null
              ))
            )
          }
        </div>
      </div>
    );
  };

  // 浮窗提示
  const bubbleContentList = useMemo(() => {
    const keys = Object.keys(bubbleData || {});
    return keys?.map((key, index) => {
      const desc = EXPLAIN_DESC_MAP?.[titleKeys?.[index]] || '';
      const lIsChange = isChange && key === 'change';
      const lNotIsChange = !isChange && key !== 'change';
      if (lIsChange || lNotIsChange) {
        let id = `overview_${titleKeys?.[index]}`;
        if (lIsChange && useChangeAmount) {
          id = `overview_change_amount`;
        }
        return {
          title: formatMessage({ id }),
          // mobile框架指标卡片 变化率卡片英文有描述
          desc: isMoblie ? desc : '',
          ...(bubbleData?.[key] || {})
        };
      }
      return undefined;
    });
  }, [bubbleData]);

  const bubbleContent = useMemo(() => {
    const content = bubbleContentList?.map((i, ind: number) => itemCont(i, ind));
    return content?.length ? content : null;
  }, [bubbleContentList]);

  const { preUnit, endUnit } = useMemo(() => ({
    preUnit: value !== '-' ? (dataSource?.preUnit || '') : '',
    endUnit: value !== '-' ? (dataSource?.endUnit || '') : '',
  }), [dataSource]);

  const time = useMemo(() => {
    const oTime = bubbleData?.dod?.this_time || '';
    const placeholder = isPlaceholderTime ? ' ' : '';
    const time = moment(oTime).isValid() ? moment(oTime).format('HH:mm') : placeholder;
    return time;
  }, [bubbleData, isPlaceholderTime]);

  const mainValueBubbleContent = useMemo(() => {
    // 仅当 mainValueBubble 为 null/undefined 时不展示气泡；
    // 0 / '0' / '' 等 falsy 值仍可能是合法的展示内容，需要透传
    if (mainValueBubble === null || mainValueBubble === undefined) return null;
    return `${mainValueBubble}${endUnit}`;
  }, [mainValueBubble, endUnit]);

  return (
    <div className={`overlay-card-content ${isMain ? 'overlay-card-flex-left' : ''}`}>
      {!isMain && <Bubble
        dark
        placement="top-start"
        content={explain ? <div className='overlay-card-desc' dangerouslySetInnerHTML={{ __html: explain }}></div> : null}
      >
        <div className="overlay-card-content-title">{name}</div>

      </Bubble>}
      {isRealTime && !isNightingale && (bubbleData?.dod?.this_time || isPlaceholderTime) && (
        <div className={`cart-margin-text ${isPlaceholderTime ? 'cart-margin-text-placeholder' : ''}`}>{time}</div>
      )}
      <div className={isRealTime ? "cart-margin-num" : isMain ? "overlay-card-content-main-num" : "overlay-card-content-num"}>
        <div className="dbd-metric-value-container">
          <CommonBubble dark placement="bottom" content={mainValueBubbleContent}>
            <span className="dbd-metric-main-value">{preUnit}{value}{endUnit}</span>
          </CommonBubble>
          <CommonBubble content = {subMetric?.explain}>
            {subMetric && (
              <span className="dbd-metric-sub-value">
                {subMetric.name}:{subMetric.value}
              </span>
            )}
          </CommonBubble>
        </div>
      </div>
      {
        showRateValue ? <Bubble
          overlayClassName={"overlay-card-content-bubble dbd-metric-card-item__bubble-overlay__up-and-down-comparison"}
          trigger="hover"
          dark
          placement= {isRightCard ? "bottom-end" : "bottom-start"}
          content={bubbleContent}
        >
          {UpsAndDownsComparison()}
        </Bubble> : <div className='overlay-card-content-placeholder' />
      }
    </div>
  );
};

export default MetricCardItem;